import React, { Component } from "react";
import {
  Row,
  Card,
  CardBody,
  Copy,
  Bold,
  Wrapper,
  Title,
  Input,
  Button
} from "app/NativeComponents/common";
import { Select, PillButton } from "app/NativeComponents/snippets";
import { formatAddress, getStateName } from "app/NativeActions";
class AddressInfo extends Component {
  constructor(props) {
    super(props);

    let state_data = [];
    for (var i = 0; i < props.states.length; i++) {
      state_data.push({
        key: i,
        label: this.props.states[i].name,
        value: this.props.states[i].abbr
      });
    }

    this.state = {
      state_data
    };
  }

  render() {
    const { address, editing_address, editing_card, colors } = this.props;
    const { state_data } = this.state;
    const { line1, line2 } = formatAddress({
      address: {
        address: address.address,
        address2: address.address2,
        address_city: address.city,
        address_state: address.state,
        address_zip: address.zip
      }
    });
    return (
      <Wrapper
        style={{
          borderBottomWidth: 1,
          borderBottomStyle: "solid",
          borderBottomColor: colors.border_color,
          paddingBottom: 20
        }}
      >
        <Wrapper style={{ padding: 10 }}>
          <Title>1.) Billing Address:</Title>
        </Wrapper>
        {!editing_address ? (
          <Wrapper style={{ padding: 20 }}>
            <Row>
              <Wrapper style={{ flex: 1, paddingRight: 10 }}>
                <Copy>
                  <Bold>{address.name}</Bold>
                </Copy>
                {!!address.email ? <Copy>{address.email}</Copy> : null}
                <Copy>{line1}</Copy>
                <Copy>{line2}</Copy>
              </Wrapper>
              <Wrapper>
                <Button
                  onPress={() => this.props.toggleEditAddress(true)}
                  style={{ padding: 10 }}
                >
                  <Copy
                    style={{
                      color: colors.active_color,
                      textAlign: "center"
                    }}
                  >
                    Edit Address
                  </Copy>
                </Button>
              </Wrapper>
            </Row>
          </Wrapper>
        ) : (
          <Wrapper>
            <Card>
              <Input
                ref="name"
                name="name"
                returnKeyType="next"
                blurOnSubmit={false}
                autoCapitalize="words"
                keyboardType="default"
                placeholder="Name On Card"
                onChange={value =>
                  this.props.editAddressField({ prop: "name", value })
                }
                onSubmitEditing={() => {}}
                value={address.name}
                type="text"
              />
              <Input
                ref="email"
                name="email"
                returnKeyType="next"
                blurOnSubmit={false}
                autoCapitalize="words"
                keyboardType="default"
                placeholder="Email Address"
                onChange={value =>
                  this.props.editAddressField({ prop: "email", value })
                }
                onSubmitEditing={() => {}}
                value={address.email}
                type="text"
              />
            </Card>
            <Card>
              <Input
                ref="address"
                name="address"
                returnKeyType="next"
                blurOnSubmit={false}
                autoCapitalize="words"
                keyboardType="default"
                placeholder="Address"
                onChange={value =>
                  this.props.editAddressField({ prop: "address", value })
                }
                onSubmitEditing={() => {}}
                value={address.address}
                type="text"
              />
              <Input
                ref="address2"
                name="address2"
                returnKeyType="next"
                blurOnSubmit={false}
                autoCapitalize="words"
                keyboardType="default"
                placeholder="Address Line 2"
                onChange={value =>
                  this.props.editAddressField({ prop: "address2", value })
                }
                onSubmitEditing={() => {}}
                value={address.address2}
                type="text"
              />
            </Card>
            <Card>
              <Input
                ref="city"
                name="city"
                returnKeyType="next"
                blurOnSubmit={true}
                autoCapitalize="words"
                keyboardType="default"
                placeholder="City"
                onChange={value =>
                  this.props.editAddressField({ prop: "city", value })
                }
                onSubmitEditing={() => {}}
                value={address.city}
                type="text"
              />
              <Select
                item_ref={"state"}
                items={state_data}
                title="State"
                label="Select a state"
                value={address.state}
                text={
                  address.state ? getStateName(address.state) : "Not Selected"
                }
                onSelect={item => {
                  this.props.editAddressField({ prop: "state", value: item });
                }}
              />

              <Input
                ref="zip"
                name="zip"
                blurOnSubmit={true}
                autoCapitalize="none"
                returnKeyType={"done"}
                keyboardType="numeric"
                placeholder="Zip Code"
                maxLength={5}
                onChange={value =>
                  this.props.editAddressField({ prop: "zip", value: value })
                }
                onSubmitEditing={() => {}}
                value={address.zip}
                type="number"
              />
            </Card>
            <PillButton
              onPress={() => {
                this.props.toggleEditAddress(false);
              }}
              primary={true}
              disabled={!this.props.addressCompleted(address)}
            >
              Save
            </PillButton>
          </Wrapper>
        )}
      </Wrapper>
    );
  }
}

export default AddressInfo;
